import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

import chevronLeft from '../images/svgs/chevron-left-circle-gray.svg'
import chevronRight from '../images/svgs/chevron-right-circle-gray.svg'

export default function DotsCarousel({ images, url, imgStyle }) {
    const [index, setIndex] = useState(0)
    const [hover, setHover] = useState(false)
    useEffect(() => setIndex(0), [images])

    const image = <Card.Img
        as={GatsbyImage}
        image={images?.length ? getImage(images[index]) : getImage(images)}
        objectFit='contain'
        alt=''
        variant="top"
        style={imgStyle}
    />

    const handleMouseEnter = (e) => {
        e.target.style.transition = '.5s'
        e.target.style.transform = 'scale(1.1)'
        setHover(true)
    }

    const handleMouseLeave = (e) => {
        e.target.style.transition = '.5s'
        e.target.style.transform = 'scale(1)'
        setHover(false)
    }
    
    return (
        <div className="position-relative text-center">
            {/* DISPLAYED IMAGE */}
            <div
                className='overflow-hidden'
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {url ? <Link to={url}>{image}</Link> : image}
            </div>

            {/* HOVER -> LEFT / RIGHT CHEVRONS */}
            {
                ((images?.length > 1) && (index !== 0) && hover) &&
                <Button onClick={() => setIndex(index - 1)} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} variant='' className='position-absolute top-50 p-0 border-0' style={{ left: 8, transform: 'translateY(-50%)' }}>
                    <img src={chevronLeft} alt=''  />
                </Button>
            }
            {
                ((images?.length > 1) && (index !== images?.length - 1) && hover) &&
                <Button onClick={() => setIndex(index + 1)} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} variant='' className='position-absolute top-50 p-0 border-0' style={{ right: 8, transform: 'translateY(-50%)' }}>
                    <img src={chevronRight} alt='' />                
                </Button>
            }

            {/* DOTS SELECTORS */}
            {(images?.length > 1) && <div className="d-flex gap-2 align-items-center position-absolute start-50 translate-middle" style={{ bottom: 16, zIndex: 1000 }}>
                {images?.map((x, i) => {
                    const last = i === images?.length - 1
                    const size = last ? 6 : 8
                    return (
                        <Button
                            key={url + x + i}
                            variant=''
                            style={{ width: size, height: size, borderRadius: size, }}
                            onClick={() => setIndex(i)}
                            className={`${index === i ? 'bg-white' : 'bg-secondary-subtle'} p-0`}
                        />
                    )
                })}
            </div>}
        </div>
    )
}